import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addSingleCommunityForumAnswer, blogList, communityForumAnswerList, communityForumList, updateSingleCorrectAnswer } from "../apis/apiHandler";

export const communityForum = createAsyncThunk(
    "community_forum/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await communityForumList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const communityForumAnswer = createAsyncThunk(
    "community_forum/answer_list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await communityForumAnswerList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addCommunityForumAnswer = createAsyncThunk(
    "community_forum/add_answer",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleCommunityForumAnswer(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateCorrectAnswer = createAsyncThunk(
    "community_forum/update_correct_answer",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await updateSingleCorrectAnswer(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const blogs = createAsyncThunk(
    "blog/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blogList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);


const initialState = {
    loading: false,
    communityForumList: [],
    communityForumAnswerList: [],
    addCommunityForumAnswerData: {},
    updateCorrectAnswerData: {},
    blogList:[],
    error: null,
    success: false,
};

const communityForumSlice = createSlice({
    name: "community forum",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(communityForum.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(communityForum.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.communityForumList = payload;
                state.success = true;
            })
            .addCase(communityForum.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(communityForumAnswer.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(communityForumAnswer.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.communityForumAnswerList = payload;
                state.success = true;
            })
            .addCase(communityForumAnswer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addCommunityForumAnswer.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addCommunityForumAnswer.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addCommunityForumAnswerData = payload;
                state.success = true;
            })
            .addCase(addCommunityForumAnswer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateCorrectAnswer.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateCorrectAnswer.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateCorrectAnswerData = payload;
                state.success = true;
            })
            .addCase(updateCorrectAnswer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(blogs.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(blogs.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.blogList = payload;
                state.success = true;
            })
            .addCase(blogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default communityForumSlice.reducer;
